<template>
  <v-container v-if="ready">
    <v-card>
      <v-card-title>
        Ordens de transporte
        <v-btn @click="refresh" :disabled="loading" icon class="ml-2">
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
      </v-card-title>

      <v-data-table :headers="headers" :items="data" :loading="loading">
        <template v-slot:item.id="{ item }">
          <router-link :to="getLink(item)" v-text="item.id"></router-link>
        </template>

        <template v-slot:item.acoes="{ item }">
          <v-btn small color="primary" elevation="0" :to="getLink(item)">
            Acessar
          </v-btn>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import locacoes from "@/services/locacoes";
import QueryMixin from "@/mixins/QueryMixin";

export default {
  mixins: [QueryMixin],

  components: {},

  props: {},

  data() {
    return {
      headers: [
        {
          text: "Código",
          value: "id"
        },
        {
          text: "Tipo",
          value: "tipo_texto"
        },
        {
          text: "Status",
          value: "status_texto"
        },
        {
          text: "Clientes",
          value: "clientes_nomes"
        },
        {
          text: "",
          value: "acoes",
          sortable: false,
          align: "right"
        }
      ]
    };
  },

  methods: {
    getLink(item) {
      return {
        name: "locacoes-ordens-transporte",
        params: {
          codigo: item.id
        }
      };
    },

    async getData() {
      return await locacoes.ordens_transporte.listarTodos();
    },

    responseToData(response) {
      return response.map(item => ({
        ...item,
        status_texto: item.confirmado ? "Confirmado" : "Pendente",
        tipo_texto: item.tipo === "E" ? "Entrega" : "Retirada",
        clientes_nomes: [
          ...new Set(item.clientes.map(cliente => cliente.nome))
        ].join(", ")
      }));
    }
  },

  computed: {}
};
</script>
